import React from "react";
import { Helmet } from "react-helmet";

import { useForm, ValidationError } from '@formspree/react';
import { useState, useEffect } from "react";

function ContactForm() {
    const [state, handleSubmit] = useForm("xqeyddyj");
    const [showMessage, setShowMessage] = useState(false);
    const [formData, setFormData] = useState({
      name: "",
      email: "",
      message: ""
    });

  // Show success message and clear form
  useEffect(() => {
    if (state.succeeded) {
      setShowMessage(true);

      // clear fields
      setFormData({
        name: "",
        email: "",
        message: ""
      });

      // hide message after 10 seconds
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [state.succeeded]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return (
    <div>
      <Helmet>
        <title>Contact Leocord | Pharmaceutical Supplier</title>

        <meta
          name="description"
          content="Contact Leocord for pharmaceutical supply inquiries, partnerships, and healthcare product distribution for hospitals and healthcare institutions."
        />

        <meta
          name="keywords"
          content="contact pharmaceutical supplier, pharma distributor contact, healthcare pharmaceutical supply"
        />

        <link rel="canonical" href="https://leocordhealthcare.com/contact" />
      </Helmet>
      <section className="contact-header">
        <div className="container">
          <h1>Contact Leocord</h1>
          <p className="lead mt-3">
            Reach out to our team for product inquiries, institutional partnerships, or distribution opportunities.
          </p>
        </div>
      </section>
      <section className="py-5">
        <div className="container">
          <div className="pb-5">
            <p>If you would like to learn more about Leocord's pharmaceutical products or discuss supply partnerships for hospitals and healthcare institutions, our team is ready to assist you.</p>
            <p>Leocord works closely with healthcare providers to deliver reliable pharmaceutical distribution and ensure timely access to essential medicines. Whether you have inquiries about our products, distribution network, or collaboration opportunities, we welcome your message.</p>
            <p>Our team will respond promptly to support your healthcare supply needs.</p>
          </div>
          <div className="row">
            <div className="col-md-6">
              {showMessage && (
                <div className="alert alert-success">
                  Message sent successfully!
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" placeholder="Full Name" required/>
                  <ValidationError 
                    prefix="Name" 
                    field="name"
                    errors={state.errors}
                  />
                </div>
                <div className="mb-3">
                  <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" placeholder="Email Address" required/>
                  <ValidationError 
                    prefix="Email" 
                    field="email"
                    errors={state.errors}
                  />
                </div>
                <div className="mb-3">
                  <textarea name="message" className="form-control" rows="4" placeholder="Message" value={formData.message} onChange={handleChange} required></textarea>
                </div>
                <ValidationError
                  prefix="Message"
                  field="message"
                  errors={state.errors}
                />
                <button className="btn btn-primary mb-3" type="submit" disabled={state.submitting}>Submit</button>
              </form>
            </div>

            <div className="col-md-6">
              <h5>Registered Office</h5>
              <p>
                Leocord Healthcare Pvt. Ltd.<br />
                Plot No: C39A, Office No: B39, Second floor,<br />
                Gami Industrial Park, S Central Road,<br />
                Pawane, Thane, Mumbai, <br />
                Maharashtra 400705, India
              </p>

              <h5>Email</h5>
              <p><a href="mailto:leocordhealthcare@gmail.com">leocordhealthcare@gmail.com</a></p>

              <h5>Phone</h5>
              <p>+91-9346896707</p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

function Contact() {
  return (
    <ContactForm />
  );
}

export default Contact;